import { forwardRef } from 'react';
import { formatDateInput } from 'utils/dateTimeUtils/dateFormatUtil';

import { Input } from '@american-autonomy/ag-ui';

import { AUTOCOMPLETE, TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const DateInput = forwardRef<HTMLInputElement, Props>(
    (
        {
            className = '',
            id,
            onBlur,
            onChange,
            onClick,
            placeholder = '',
            testId = TEST_ID,
            value
        },
        ref
    ) => {
        const handleChange = (rawValue: string) => {
            const formatted = formatDateInput(rawValue);

            if (ref && 'current' in ref && ref.current) {
                ref.current.value = formatted;
            }

            onChange?.();
        };

        return (
            <Input
                autocomplete={AUTOCOMPLETE}
                className={`${className} ${styles.dateInput}`}
                id={id}
                onBlur={onBlur}
                onChange={handleChange}
                onClick={onClick}
                placeholder={placeholder}
                ref={ref}
                testId={testId}
                value={value}
            />
        );
    }
);

DateInput.displayName = 'DateInput';

export default DateInput;
